module.exports = __webpack_public_path__ + "static/media/IRIS_temoignages.f77e3b99.jpg";